import React from 'react';

import styled, { keyframes } from 'styled-components';

const drawCircle = keyframes` 
    0% {
        stroke-dasharray: 0 240;
    }
    100% {
        stroke-dasharray: 240 0;
    }
`;

const drawCheck = keyframes` 
    0% {
        stroke-dasharray: 0 44;
    }
    100% {
        stroke-dasharray: 44 0;
    }
`;

const StyledSvg = styled.svg`
    width: 80px;
    height: 80px;
    overflow: visible;
`;

const Circle = styled.path`
    fill: none;
    stroke: ${(props) => props.theme.purple_100};
    stroke-width: 3;
    stroke-dasharray: 240;
    stroke-dashoffset: 180;
    animation: ${drawCircle} 1s ease-out forwards;
`;

const Checkmark = styled.path`
    fill: none;
    stroke: ${(props) => props.theme.purple_100};
    stroke-width: 3;
    stroke-linecap: round;
    stroke-dasharray: 44;
    stroke-dashoffset: 44;
    animation: ${drawCheck} 0.5s ease-out 1s forwards;
`;

export const AnimatedIconSuccess = () => {
    return (
        <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
            <Circle d="M5 40C5 20.67 20.67 5 40 5C59.33 5 75 20.67 75 40C75 59.33 59.33 75 40 75C20.67 75 5 59.33 5 40Z" />
            <Checkmark d="M27.06 39.94L36 48.88L56.94 27.94" />
        </StyledSvg>
    );
};
